var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getUrlFromProps } from "../../resources/functions/";

import { isSelect, optionsList } from "../Schema/utils/";

import { Module, ModuleLink, ModuleGrid, ModuleMedia, ModuleAvatar, ModuleIcon, ModuleContent, ModuleHeader, ModuleFooter, ModuleBody, ModuleTitle, ModuleEmail, ModuleLabel, ModuleMetadata, ModuleStatus, ModuleByline, ModuleAction, NavSettings } from '../';

import AuthOptions from "./AuthOptions";

import "./AuthModule.scss";

var AuthModule = (_temp2 = _class = function (_Component) {
    _inherits(AuthModule, _Component);

    function AuthModule() {
        var _temp, _this, _ret;

        _classCallCheck(this, AuthModule);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onAuthChange = function (value) {

            if (_this.props.onAuth) {
                _this.props.onAuth(value);
            }
        }, _this.getProps = function () {
            var _this$props = _this.props,
                metadata = _this$props.metadata,
                name = _this$props.name,
                title = _this$props.title;


            var url = getUrlFromProps(_this.props);

            return _extends({}, _this.props, {
                url: url,
                editUrl: url,
                title: title || name,
                metadata: metadata
            });
        }, _this.getAuthSchemaOptions = function (schema) {
            var options = isSelect(schema) && optionsList(schema);

            if (!options) {
                return false;
            }

            return options;
        }, _this.getAuthOptions = function () {
            var _this$props2 = _this.props,
                schema = _this$props2.schema,
                formData = _this$props2.formData,
                authName = _this$props2.authName,
                authValue = _this$props2.authValue,
                authOptions = _this$props2.authOptions;


            if (schema && schema.properties && schema.properties[authName]) {
                authOptions = _this.getAuthSchemaOptions(schema.properties[authName]);
            }

            authValue = formData[authName] || _this.props[authName] || authValue || undefined;

            return {
                options: authOptions,
                value: authValue
            };
        }, _this.renderFooter = function () {
            var _this$props3 = _this.props,
                authorize = _this$props3.authorize,
                authStatus = _this$props3.authStatus,
                status = _this$props3.status;


            var authOptions = _this.getAuthOptions();

            if (authOptions) {
                return React.createElement(
                    ModuleFooter,
                    null,
                    React.createElement(AuthOptions, _extends({}, authOptions, { onChange: _this.onAuthChange })),
                    ' ',
                    ' ',
                    React.createElement(ModuleStatus, { status: authStatus })
                );
            }

            return React.createElement(
                ModuleFooter,
                null,
                React.createElement(ModuleStatus, { status: status }),
                ' ',
                ' ',
                React.createElement(ModuleByline, _extends({}, _this.props, { name: false }))
            );
        }, _this.renderHeader = function () {
            var _this$props4 = _this.props,
                authType = _this$props4.authType,
                theme = _this$props4.theme,
                abbr = _this$props4.abbr,
                title = _this$props4.title,
                name = _this$props4.name,
                email = _this$props4.email,
                metadata = _this$props4.metadata,
                icon = _this$props4.icon;


            if (authType === "owner" || authType === "site") {
                return React.createElement(
                    ModuleHeader,
                    null,
                    React.createElement(ModuleAvatar, _extends({}, _this.props, { abbr: abbr || name, theme: theme })),
                    React.createElement(
                        ModuleContent,
                        null,
                        React.createElement(ModuleTitle, { title: title || name }),
                        ' ',
                        ' ',
                        React.createElement(ModuleLabel, _this.props),
                        ' ',
                        ' ',
                        React.createElement(ModuleMetadata, { metadata: metadata })
                    )
                );
            }

            if (authType === "app") {
                return React.createElement(
                    ModuleHeader,
                    null,
                    React.createElement(ModuleMedia, _extends({}, _this.props, { svg: icon, mediaType: 'svg' })),
                    React.createElement(
                        ModuleContent,
                        null,
                        React.createElement(ModuleTitle, { title: title || name }),
                        ' ',
                        ' ',
                        React.createElement(ModuleLabel, _this.props),
                        ' ',
                        ' ',
                        React.createElement(ModuleMetadata, { metadata: metadata })
                    )
                );
            }

            if (authType === "user") {
                return React.createElement(
                    ModuleHeader,
                    null,
                    React.createElement(ModuleAvatar, _extends({}, _this.props, { theme: undefined })),
                    React.createElement(
                        ModuleContent,
                        null,
                        React.createElement(ModuleTitle, { title: title || name }),
                        ' ',
                        ' ',
                        React.createElement(ModuleLabel, _this.props),
                        ' ',
                        ' ',
                        React.createElement(ModuleEmail, { email: email }),
                        React.createElement(ModuleMetadata, { metadata: metadata })
                    )
                );
            }

            return React.createElement(
                ModuleHeader,
                null,
                React.createElement(ModuleMedia, _this.props),
                React.createElement(
                    ModuleContent,
                    null,
                    React.createElement(ModuleTitle, { title: title }),
                    ' ',
                    ' '
                )
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    AuthModule.prototype.render = function render() {
        var _getProps = this.getProps(),
            url = _getProps.url,
            editUrl = _getProps.editUrl,
            onClick = _getProps.onClick;

        return React.createElement(
            Module,
            this.props,
            React.createElement(
                ModuleGrid,
                this.props,
                React.createElement(
                    ModuleLink,
                    { url: url, onClick: onClick },
                    this.renderHeader()
                ),
                this.renderFooter()
            ),
            React.createElement(ModuleAction, _extends({}, this.props, { editUrl: editUrl }))
        );
    };

    return AuthModule;
}(Component), _class.defaultProps = {
    urlPattern: "/auth/:uniqueId",
    moduleType: "auth",
    moduleLayout: "table",
    moduleSize: "auto",
    label: undefined,
    labelColor: undefined,
    action: ["edit", "remove", "select"],

    authorize: false,

    authName: "authId",
    authValue: undefined,
    authOptions: undefined,
    authStatus: undefined,

    formData: {},
    schema: {}
}, _temp2);
AuthModule.propTypes = process.env.NODE_ENV !== "production" ? {
    expanded: PropTypes.string,
    editable: PropTypes.string,
    editing: PropTypes.string,
    removable: PropTypes.string,
    authType: PropTypes.string,
    authOptions: PropTypes.array,
    authName: PropTypes.string,
    authValue: PropTypes.string
} : {};


export default AuthModule;